import { post, get } from "../network/index.js";
// 新建价格策略
const addStrategy = (data) => {
    return post("/mercWebi/goodsStrategy/addStrategy", data);
};
// 查询列表
const queryList = (data) => {
    return post("/mercWebi/goodsStrategy/queryList", data);
};
// 商品品管理 --> 分组查询全部商品信息
const listGoodsInfoBySubarea = (data) => {
    return post("/mercWebi/busGoodsInfo/listGoodsInfoBySubarea", data);
};
// 商品品管理 --> 价格策略-商品，规格列表
const listGoodsPriceStrategy = data => {
  return post('/mercWebi/busGoodsInfo/listGoodsPriceStrategy', data)
}
// 商品品管理 --> 编辑价格策略
const updateStrategy = (data) => {
    return post("/mercWebi/goodsStrategy/updateStrategy", data);
};
// 商品品管理 -->价格策略详情
const queryDetail = (data) => {
    return post("/mercWebi/goodsStrategy/queryDetail", data);
};

// 商品品管理 -->删除价格策略
const deleteStrategy = (data) => {
    return post("/mercWebi/goodsStrategy/deleteStrategy", data);
};
// 商品品管理 -->查询商品信息(库存)
const queryGoodsInfoByParam = (data) => {
    return post("/mercWebi/busGoodsInfo/queryGoodsInfoByParam", data);
};
// 商品品管理 -->修改商品库存
const modifyGoodsStock = (data) => {
    return post("/mercWebi/busGoodsInfo/modifyGoodsStock", data);
};
// 商品品管理 -->更新价格策略状态
const updateStrategyStatus = (data) => {
    return post("/mercWebi/goodsStrategy/updateStrategyStatus", data);
};
// 商品品管理 -->修改商品基本信息
const modifyGoodsOther = (data) => {
    return post("/mercWebi/busGoodsInfo/modifyGoodsOther", data);
};

export default {
    addStrategy,
    queryList,
    listGoodsInfoBySubarea,
    listGoodsPriceStrategy,
    updateStrategy,
    queryDetail,
    deleteStrategy,
    queryGoodsInfoByParam,
    modifyGoodsStock,
    updateStrategyStatus,
    modifyGoodsOther
};
